const aisSearchAPIURL = 'https://api.phila.gov/ais/v1/search/';
const aisSearchAPIKey = process.env.AIS_SEARCH_KEY;

export default function makeAISSearchURL(query) {
    return `${aisSearchAPIURL}${query}?gatekeeperKey=${aisSearchAPIKey}`;
}
